function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * An ItemSearchProvider provides an API for searching within an item.
 *
 */
export default class ItemSearchProvider {
  constructor(options, parameterOptions) {
    this.options = options;
    this.parameterOptions = parameterOptions;
    /**
     * An optional hook to receive a hint that the user might search the parameter with `parameterId`.
     *
     * If indexes for parameters takes too long to load, implementing this method can
     * improve search time by pre-emptively loading the index. This hook is called
     * while the user is inputing value for the parameter. It can be called
     * multiple times, so the implementation must take care not to make
     * duplicate requests.
     */
    _defineProperty(this, "loadParameterHint", void 0);
  }

  /**
   * Called once on start to initialize the item search provider.
   *
   * @return A promise that resolves when the initialization is complete.
   */

  /**
   * Returns a list of parameters that can be searched.
   *
   * @return A promise that resolves to an array of ItemSearchParameter.
   */

  /**
   * Perform a search.
   *
   * @param parameterValues A map from parameter ID to its value.
   * @return A promise that resolves to an array of ItemSearchResult.
   */
}